/* ***  VERSION 1.0.0  *** */

/**
 * Trim space(s) from left side of the string - alias for trimStart, if there
 * @returns  {string}  The trimmed string
 */
String.prototype.ltrim = function ()
{
	return this.hasOwnProperty('trimStart') ? this.replace(/^\s+/, '') : this.trimStart();
}

/**
 * Trim space(s) from right side of the string - alias for trimEnd, if there
 * @returns  {string}  The trimmed string
 */
String.prototype.rtrim = function ()
{
	return this.hasOwnProperty('trimEnd') ? this.replace(/\s+$/, '') : this.trimEnd();
}

/**
 * Pad a string on the left side - alias for padStart, if there
 * @param    {string}  padString  The string to fill with
 * @param    {number}  length     The final length to reach
 * @returns  {string}             The padded string
 */
String.prototype.lpad = function (padString, length)
{
	if (this.hasOwnProperty('padStart')) return this.padStart(length, padString);
	else
	{
		let str = this;
		while (str.length < length) str = padString + str;
		return str;
	}
}

/**
 * Pad a string on the right side - alias for padEnd, if there
 * @param    {string}  padString  The string to fill with
 * @param    {number}  length     The final length to reach
 * @returns  {string}             The padded string
 */
String.prototype.rpad = function (padString, length)
{
	if (this.hasOwnProperty('padEnd')) return this.padEnd(length, padString);
	else
	{
		let str = this;
		while (str.length < length) str = str + padString;
		return str;
	}
}

/**
 * Replace all instances of a string inside another one
 * @param    {string}  search   The string to search for
 * @param    {string}  replace  The string to replace with
 * @returns  {string}           String with all replacements
 */
String.prototype.replaceAll = function (search, replace)
{
	return this.hasOwnProperty('replaceAll') ? this.replaceAll(search, replace) : this.split(search).join(replace);
}

/**
 * Capitalize the first letter of a string
 * @returns  {string}  The capitalized string
 */
String.prototype.ucfirst = function ()
{
	return this.charAt(0).toUpperCase() + this.slice(1);
}